import React, { Component, PropTypes } from 'react';
import { Form, SubmissionError, Field, FieldArray } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import ModalDialog from 'common/components/modal/modal_dialog';
import { TextAreaField, RadioButtonField } from 'common/components/form_fields';
import ParticipantsField from 'presentations/components/participants_field';
import ParticipantMsgPreview from 'presentations/containers/participant_msg_preview';

export default class AddParticipantsModal extends Component {
  constructor(props) {
    super(props);

    this.state = { showingMsgPreview: false };

    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleMsgPreview = this.toggleMsgPreview.bind(this);
  }

  toggleMsgPreview() {
    this.setState({ showingMsgPreview: !this.state.showingMsgPreview });
  }

  handleSubmit(formData) {
    const { addRequest, fetch } = this.props;

    const promises = formData.participants.map(p => (
      addRequest({ ...p, invite_message: formData.invite_message })
    ));

    return Promise.all(promises).then(() => {
      /* fetch update participants list and close modal */
      fetch();
      this.handleClose();
    }).catch(res => {
      throw new SubmissionError({ _error: 'Failed to add participants. Please try again.' });
    });
  }

  handleClose() {
    this.props.reset();
    this.props.toggle();
  }

  render() {
    const {
      showing, handleSubmit, submitting, error, submitFailed, valid, submit, weightVotes
    } = this.props;
    const { showingMsgPreview } = this.state;

    return (
      <ModalDialog modalOpen={showing} closeAction={this.handleClose}
        modalHeader="Add Participants" dialogClasses="add-participants-modal">

        <Form onSubmit={handleSubmit(this.handleSubmit)}>
          <fieldset>
            <h3>Participant Email</h3>
            <FieldArray name="participants" component={ParticipantsField} props={{ weightVotes }} />
          </fieldset>
          <fieldset>
            <h3>Personal Message</h3>
            <p>
              We'll include this message in the invitation email we send to each participant.<br/>
              You can <a onClick={this.toggleMsgPreview}>preview the invitation</a> to see
              what your invitees will receive.
            </p>
            <Field name="invite_message" component={TextAreaField} rows={5}/>
          </fieldset>
        </Form>

        <div className="modal-actions">
          <AnimatedButton processing={submitting} onClick={submit}
            disabled={!valid && !submitFailed} label="Add" processingLabel="Adding..."
            errorMsg={error || submitFailed} />
          <button className="btn btn-text" onClick={this.handleClose}>
            Cancel
          </button>
        </div>
        <ParticipantMsgPreview showing={showingMsgPreview} onClose={this.toggleMsgPreview} />
      </ModalDialog>
    );
  }
};

AddParticipantsModal.propTypes = {
  addRequest: PropTypes.func.isRequired,
  fetch: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  showing: PropTypes.bool.isRequired,
  weightVotes: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./presentations/components/add_participants_modal.jsx